import React, { useContext } from 'react';
import {
    VenueAnalysisData,
    VenueAnalysisVenueData,
} from 'widgets/venueAnalysis/venueAnalysisAggregatedData';

import './VenueExecCapsuleContentBack.scss';
import AppContext from 'app/AppContext';
import InfoBox from 'utils/components/InfoBox/InfoBox';
import { VenueAnalysisCapsuleConfigStateView } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { toVenueExecCapsuleData } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/content/venueExecCapsuleData';
import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';

export interface VenueExecCapsuleContentBackProps {
    data: VenueAnalysisData;
    view: VenueAnalysisCapsuleConfigStateView;
    showOrderData: boolean;
}

export function VenueExecCapsuleContentBack(
    props: VenueExecCapsuleContentBackProps
) {
    const { data, view, showOrderData } = props;
    const { numberFormat } = useContext(AppContext);

    const { histDisplayData, todayDisplayData, orderDisplayData } =
        toVenueExecCapsuleData(data);

    const cssClasses = 'VenueExecCapsuleContentBack capsule-values flippable';

    if (view === 'back-today') {
        return <Values title="Today" venues={todayDisplayData} />;
    }
    if (view === 'back-order') {
        if (!showOrderData) {
            return (
                <div className={cssClasses}>
                    <div className="title">Order</div>
                    <InfoBox info={'No orders selected'} />
                </div>
            );
        }
        return <Values title="Order" venues={orderDisplayData} />;
    }

    return <Values title="Historical" venues={histDisplayData} />;

    function Values(props: {
        title: string;
        venues: VenueAnalysisVenueDisplayData[];
    }) {
        const { title, venues } = props;
        return (
            <div className={cssClasses}>
                <div className="title">{title}</div>
                <div className="values">
                    {venues.map((v) => (
                        <VenueRow venue={v} key={v.name} />
                    ))}
                </div>
            </div>
        );
    }

    function VenueRow(props: { venue: VenueAnalysisVenueData }) {
        const { venue } = props;
        const { name, percent } = venue;
        return (
            <div className="venue-row">
                <div className="label">{name}</div>
                <div className="value">
                    {percent < 1
                        ? `${numberFormat.n2(percent)}%`
                        : percent < 10
                        ? `${numberFormat.n1(percent)}%`
                        : `${numberFormat.n0(percent)}%`}
                </div>
            </div>
        );
    }
}
